<template>
    <rkm-area
        title="Unidades executoras"
        type="fieldset"
    >
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="unidades"
                        :validations="validations.unidade"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            hide-filters
            :items="data.model.unidadesExecutoras"
            :fields="fields"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-area>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true }
            }
        },
        unidades() {

            return this.data.form.unidades.filter(u =>
                !this.data.model.unidadesExecutoras.find(ue => ue.unidadeId === u.id))
        },
    },
    data: () => ({
        model: {
            unidadeId: null,
        },
        fields: [
            { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' }
        ]
    }),
    methods: {
        add() {

            const data = this.clone(this.model)

            data.unidadeNomeFantasia = this.data.form.unidades.find(u => u.id === data.unidadeId).nomeFantasia

            this.data.model.unidadesExecutoras.push(data)

            this.resetForm()
        },
        resetForm() {

            this.model.unidadeId = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        handleDestroy(unidadeExecutora) {

            const destroy = async () => {

                this.data.model.unidadesExecutoras.splice(this.data.model.unidadesExecutoras.indexOf(unidadeExecutora), 1)
            }

            this.showDeleteConfirmation('Deseja realmente excluir a unidade executora?', destroy)
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true }
    }
}
</script>